import { render, staticRenderFns } from "./ReservationView.vue?vue&type=template&id=b849a87a"
import script from "./ReservationView.vue?vue&type=script&lang=js"
export * from "./ReservationView.vue?vue&type=script&lang=js"
import style0 from "./ReservationView.vue?vue&type=style&index=0&id=b849a87a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports